module.exports = __webpack_public_path__ + "components/rewards/sixt/static/logo-b3a3e7ac3e2ff0c382d3f61ad509a2dc.jpg";